import * as Yup from 'yup';
import { ILoginFormStore, ILoginInputs, LoginInputKeys } from "./types";

// Изначальные данные полей ввода в форме авторизации
export const INITIAL_LOGIN_STORE: ILoginFormStore = {
    loginInput: {
        value: '',
        type: 'text',
        isValid: true,
        errorMessage: ''
    },
    passwordInput: {
        value: '',
        type: 'password',
        isValid: true,
        errorMessage: ''
    },
}

// Массив полей ввода для отрисовки
export const INPUTS_ARR: ILoginInputs[] = [
    {
        label: 'Логин',
        inputName: LoginInputKeys.LOGIN_INPUT,
    },
    {
        label: 'Пароль',
        inputName: LoginInputKeys.PASSWORD_INPUT,
    },
];


export const LOGIN_INPUT_SCHEMA = Yup.object({
    value: Yup.string()
        .required('Введите логин')
});

export const PASSWORD_INPUT_SCHEMA = Yup.object({
    value: Yup.string()
        .required('Введите пароль')
});


// Схема валидации формы авторизации
export const LOGIN_VALIDATION_SCHEMA = Yup.object().shape({
    loginInput: LOGIN_INPUT_SCHEMA,
    passwordInput: PASSWORD_INPUT_SCHEMA,
});

